exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".foi-page-header.page-heading{background:transparent!important;border-bottom:0!important;padding-bottom:0!important;padding-left:10px!important;padding-right:10px!important;margin-top:20px}.foi-page-header.page-heading>.col-lg-12{padding-left:0!important;padding-right:0!important}.foi-page-header.page-heading>.col-lg-12>h2{display:block;width:100%;margin:0 0 8px;padding:8px 16px;background:#fff;border:1px solid rgba(0,0,0,.08);border-radius:15px;color:#1c5ca7;font-size:22px;font-weight:600}.resources-page-title{margin:0;color:#1c5ca7}.foi-page.wrapper.wrapper-content{background:#fff;border:1px solid rgba(0,0,0,.08);border-radius:15px;padding:14px 16px 16px}.foi-page textarea{width:100%;max-width:100%;box-sizing:border-box}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./Client/app/views/resources/resources.component.css
// module id = 1222
// module chunks = 0